import React, { useState, useEffect } from "react";
import "./Navbar.css";

function Navbar() {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    // Smooth scroll for anchor links
    const handleNavClick = (e) => {
      if (
        e.target.tagName === "A" &&
        e.target.getAttribute("href")?.startsWith("#")
      ) {
        const targetId = e.target.getAttribute("href").slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };
    document.querySelector(".navbar").addEventListener("click", handleNavClick);

    // Scroll effect for navbar and active section logic
    const handleScroll = () => {
      const sections = ["home", "features", "about", "projects", "contact"];
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom > 100) {
            setActiveSection(section);
            break;
          }
        }
      }
      // Add shadow or background to navbar on scroll
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 20) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      document
        .querySelector(".navbar")
        .removeEventListener("click", handleNavClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isActive = (section) =>
    activeSection === section ? "navbar-item active" : "navbar-item";

  return (
    <nav className="navbar">
      <ul className="nav-links left-links">
        <li>
          <a href="#features" className={isActive("features")}>
            Services
          </a>
        </li>
        <li>
          <a href="#about" className={isActive("about")}>
            About
          </a>
        </li>
      </ul>

      <div className="logo">
        <a href="#home" className="navbar-logo">
          <h1>MadeByAngel</h1>
        </a>
      </div>

      <ul className="nav-links right-links">
        <li>
          <a href="#projects" className={isActive("projects")}>
            Projects
          </a>
        </li>
        <li>
          <a href="#contact" className={isActive("contact")}>
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
